import body from "../../index.module.scss"
import classes from "./presentation.module.scss"

import Image from "../Image/Image"

import presentation from "../Assets/Img/Src/presentation.jpg"
import presentationWebp from "../Assets/Img/Webp/presentation.webp"
import Advantage from "./Advantage/Advantage"
import History from './History/History';



//---------------------------------------------
const Presentation = () => { 

  
  return (
    <section className={classes.Presentation}>
        <div className={classes.Img}>
          <Image
              src={presentation}
              srcWebp={presentationWebp}
          />
        </div>
      <div className={body.container}>
        <div className={classes.wrapper}>
          <div className={classes.left}>
              <h1  className={classes.title}>
              Кейс о том, как мы подняли трафик <span className={classes.Accent}>в 15 раз</span>
              </h1>
            <p className={classes.about}>Группа компаний <b>Топол-эко</b></p>
          </div>

          <Advantage/>
          <History/>
        </div>
      </div>
    </section>
  )
}

export default Presentation